import { useState } from "react";
import localization from "../../../../config/localization";
import { Button } from "../../../../components/ui/Button";
import { PhoneNumberInput } from "../../../../components/ui/inputs/PhoneNumberInput";
import userService from "../../services/user.service";
import { toastService as toast } from "../../../../components/ui/toast/toast.service";
import { OtpModal } from "../../../../components/ui/modals";
import { useNavigate } from "react-router-dom";
import { changeLoginModalState } from "../../../../reducers/appStateReducer";
import { useAppDispatch } from "../../../../store/hooks";
import { Validations } from "../../../../models/constants/validations";

export function MobileVerification({
  userId,
  handleBackButton,
}: {
  userId: string;
  handleBackButton: () => void;
}) {
  const [mobile, setMobile] = useState("");
  const [mobileErrorMessage, setMobileErrorMessage] = useState<string | null>(null);
  const [showMobileVerificationModal, setShowMobileVerificationModal] =
    useState(false);
  const [mobileVerificationErrorMessage, setMobileVerificationErrorMessage] =
    useState("");

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const countryCode = "+91";

  const handleVerifyMobile = () => {
    if (validateMobile()) {
      handleSendMobileVerificationCode();
    }
  };

  const clearMobileErrorMessageOnFocus = () => {
    setMobileErrorMessage((prev) => (prev ? null : prev));
  };

  const handleMobileChange = (value: string) => {
    setMobile(value);
    setMobileErrorMessage((prev) => (value ? null : prev));
  };

  const validateMobile = () => {
    setMobileErrorMessage(null);
    if (!mobile) {
      setMobileErrorMessage("enter_mobile");
      return false;
    }
    if (!Validations.mobile.regex.test(mobile)) {
      setMobileErrorMessage("mobile_validation_error");
      return false;
    }
    return true;
  };

  const handleSendMobileVerificationCode = () => {
    userService
      .sendMobileVerificationCode(userId, mobile, countryCode)
      .then((response) => {
        if (response.isSuccess) {
          var message = localization.getString(response.message);
          toast.success(message);
          setTimeout(() => {
            setShowMobileVerificationModal(true);
          }, 1000);
        }
      });
  };

  const handleResendMobileVerificationCode = () => {
    userService
      .sendMobileVerificationCode(userId, mobile, countryCode)
      .then((response) => {
        if (response.isSuccess) {
          var message = localization.getString(response.message);
          toast.success(message);
          setMobileVerificationErrorMessage("");
        }
      });
  };

  const handleVerifyMobileVerificationCode = (otp: string) => {
    userService.verfiyMobileVerificationCode(userId, otp).then((response) => {
      if (response.isSuccess) {
        setTimeout(() => {
          setShowMobileVerificationModal(false);
          navigate("/");
          dispatch(changeLoginModalState(true));
        }, 1000);
      }
    });
  };

  const handleCloseMobileVerificationModal = () => {
    setShowMobileVerificationModal(false);
    setMobileVerificationErrorMessage("");
  };

  return (
    <div>
      <PhoneNumberInput
        label={localization.mobile}
        placeholder={localization.enter_mobile}
        value={mobile}
        showCountryCode={true}
        iconText={!showMobileVerificationModal ? localization.verify_btn : ""}
        iconClassName="px-3 py-1 text-sm font-semibold text-white whitespace-nowrap cursor-pointer"
        onButtonClick={handleVerifyMobile}
        error={mobileErrorMessage && localization.getString(mobileErrorMessage)}
        onFocus={clearMobileErrorMessageOnFocus}
        onChange={handleMobileChange}
        isRequired={true}
        maxLength={10}
        minLength={10}
      />

      <OtpModal
        open={showMobileVerificationModal}
        inline={true}
        onSubmit={(otp) => {
          handleVerifyMobileVerificationCode(otp);
        }}
        errorMessage={mobileVerificationErrorMessage}
        onResend={() => handleResendMobileVerificationCode()}
        onClose={handleCloseMobileVerificationModal}
      />

      <Button
        type="submit"
        className="mt-4 w-full py-4 rounded-md text-white bg-primary-gradient"
        onClick={handleBackButton}
      >
        <span className="tracking-wider">{localization.back}</span>
      </Button>
    </div>
  );
}
